import amountTypeOptions from "@coworker/enums/amountTypes";
import taskStateOptions from "@coworker/enums/taskState";
import { isFinishedState } from "../constants/taskState";
import { isoDate } from "./dates";

const { CLOSED, COMPLETED } = taskStateOptions;

export function getAmounts(task) {
  if (!task) return {};
  return {
    requested: [
      task.actual_requested_quantity,
      task.requested_quantity,
      task.requested_type,
    ],
    picked: task.picked && [
      task.actual_pick_quantity || task.actual_requested_quantity,
      task.pick_quantity || task.requested_quantity, // PLAN: Rebuild frontend to remove || task.requested_quantity
      task.pick_type || task.requested_type,
    ],
    refilled:
      (task.state === CLOSED && [0, 0, "pieces"]) ||
      (task.state === COMPLETED && [
        task.actual_refilled_quantity ||
          task.actual_pick_quantity ||
          task.actual_requested_quantity,
        task.refilled_quantity || task.pick_quantity || task.requested_quantity,
        task.refilled_type || task.pick_type || task.requested_type,
      ]),
  };
}

export function getAmountByProductUnit(totalAmount, type, task) {
  if (totalAmount) {
    if (type === amountTypeOptions.MULTI_PACK && task.pieces_per_multi_pack)
      return totalAmount / task.pieces_per_multi_pack;
    else if (type === amountTypeOptions.PALLET && task.pieces_per_pallet)
      return totalAmount / task.pieces_per_pallet;
  }
  return totalAmount;
}

export function getPiecesInformation(type, piecesQuantity, t) {
  if (
    type === amountTypeOptions.MULTI_PACK ||
    type === amountTypeOptions.PALLET
  )
    return `(${piecesQuantity} ${t("piecesUnit")})`;
  else return ``;
}

export const isOverdue = (task) => {
  if (!task.due_date || isFinishedState(task.state)) return false;
  const dueDate = isoDate(task.due_date);
  const now = isoDate(new Date());
  return now > dueDate;
};
